import React from 'react'
import { Text } from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel} from 'react-bootstrap'
import moment from 'moment-jalaali'

export default ({setValue, getTouched, getError, birthdate, user, toggler, submitForm}) => {
  if (window.__BROWSER_ENV__) {
    var { DatePicker } = require('react-persian-datepicker-ali')
  }

  return (
    <Form horizontal onSubmit={submitForm}>
      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          نام
        </Col>
        <Col xs={8}>
          <Text
            field="name_fa"
            placeholder="به فارسی"
            className="form-control"
            disabled={!user.currentUser.canChangeName}
          />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          معادل
        </Col>
        <Col xs={8}>
          <Text
            field="name"
            placeholder="به انگلیسی"
            className="form-control"
            disabled={!user.currentUser.canChangeName}
          />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          تاریخ خرید
        </Col>
        <Col xs={8}>
          <DatePicker
            className="form-control"
            calendarStyles={{zIndex: 1060}}
            inputFormat="jYYYY/jMM/jDD"
            closeOnSelect
            onChange={value => {
              setValue('date', value.format('jYYYY-jMM-jDD'))
            }}

            max={moment()}
            min={moment().year(birthdate || 1900)}
          />
          <div className="FormError">{getTouched('date') && getError('date')}</div>
        </Col>
      </FormGroup>

      <FormGroup>
        <Col xsOffset={1} xs={5}>
          <Button className="btnBlock" onClick={() => toggler(false)}>
            انصراف
          </Button>
        </Col>
        <Col xsOffset={1} xs={5}>
          <Button type="submit" className="btnBlock" bsStyle="primary">
            تأیید
          </Button>
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/OwnerBox/OwnerBoxForm.js